module.exports = __webpack_public_path__ + "static/media/confirmed.1dd1291c.png";